import * as tslib_1 from "tslib";
// 各个场景tab 内容
import React, { useState, useEffect } from 'react';
import LoadingWrapper from '@/components/LoadingWrapper';
import Placeholder from '@/components/Placeholder';
import { detailConfig } from '@/shared/PageConfig';
import createElement from '@/shared/createElement';
import TabAnchor from '@/components/TabAnchor';
import { getSceneDesc, getDataDemos } from '@/services/request';
import API_BASE from '@/services/config';
import authIns, { ZHUGE_AUTH } from '@/shared/authz';
import styles from './index.module.less';
const sceneHelperMap = {
    dataEffect: {
        code: 'data-effect',
        title: '数据效果',
    },
    interfaceExperience: {
        code: 'interface-experience',
        title: '接口体验',
    },
};
function genAchoNode(scene) {
    const navs = [
        {
            code: 'scene-introduction',
            title: '场景介绍',
        },
    ];
    Object.keys(sceneHelperMap).forEach((key) => {
        if ((key === 'dataEffect' &&
            (scene.keyIndexes || scene.relatedIndexes || scene.recommendIndexes) &&
            authIns.initializedAuthData &&
            authIns.hasPermission(ZHUGE_AUTH)) ||
            (key !== 'dataEffect' && scene[key])) {
            navs.push(sceneHelperMap[key]);
        }
    });
    return <TabAnchor navs={navs}/>;
}
export default function SceneTabpane(props) {
    const [fetched, setFetched] = useState(false);
    const [state, setState] = useState({});
    const [error, setError] = useState(false);
    const { scene } = props;
    useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const params = {
                    bizCode: scene.bizCode,
                    sceneCode: scene.sceneCode,
                };
                const introduction = yield getSceneDesc(params); // 场景介绍
                let dataEffectValue;
                if (authIns.initializedAuthData &&
                    authIns.hasPermission(ZHUGE_AUTH) &&
                    (scene.keyIndexes || scene.relatedIndexes || scene.recommendIndexes)) {
                    dataEffectValue = yield getDataDemos(params); // 数据效果
                    dataEffectValue.showKeyIndexes = scene.keyIndexes;
                    dataEffectValue.showRelatedIndexes = scene.relatedIndexes;
                    dataEffectValue.showRecommendIndexes = scene.recommendIndexes;
                    dataEffectValue.sceneCode = scene.sceneCode;
                }
                let interfaceExperience;
                if (scene.interfaceExperience) {
                    interfaceExperience = {
                        params: scene.interfaceInfo,
                        url: API_BASE.interfaceExperienceUrl,
                    };
                }
                setState({
                    introduction,
                    dataEffectValue,
                    interfaceExperience,
                });
                setFetched(true);
                setError(false);
            }
            catch (e) {
                setFetched(true);
                setError(true);
            }
        });
        fetchData();
    }, []);
    return (<div className="detail-tabpane">
      <LoadingWrapper loading={!fetched} style={{ position: 'absolute' }}>
        {fetched && !error && (<>
            {genAchoNode(scene)}
            <section>{createElement(detailConfig, state)}</section>
          </>)}
        {error && (<Placeholder className={styles['position-center']} text="对不起，页面出错啦!"/>)}
      </LoadingWrapper>
    </div>);
}
